module.exports = __webpack_public_path__ + "static/media/icon-mapmarker-pin.3452dd1c.svg";